// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4c52c544","413":"8cf54e0d","988":"503a27b6"}[chunkId] + ".chunk.js";
};